<template>
  <div>
    <div v-if="!recordList.length" class="no-data">
      No Data
    </div>
    <div v-for="(item,index) in recordList" :key="index" class="item" @click="goToDetail(item)">
      <div class="item-header">
        <div class="name">
          {{ item.productName }}
        </div>
        <div class="arrow">
          <md-icon name="arrow-right" size="sm"></md-icon>
        </div>
      </div>
      <div class="item-content">
        <div class="balance">
          <div class="content-label">{{ $t('balance') }}</div>
          <div class="content-number">
            <div v-if="item.orderType === 'FIXED_TRIAL'">
              {{ item.extraAmount + item.extraCurrentRevenue | formatMoney }}
            </div>
            <div v-else>
              {{ item.amount + item.extraAmount + item.currentRevenue + item.extraCurrentRevenue | formatMoney }}
            </div>
          </div>
        </div>
        <div class="revenue">
          <div class="content-label">{{ $t('revenue') }}</div>
          <div class="content-number">
            {{ item.orderType === 'FIXED_TRIAL' ? item.extraCurrentRevenue :
            item.currentRevenue + item.extraCurrentRevenue | formatMoney }}
          </div>
        </div>
      </div>
      <div v-if="item.fundingStatus === 'REPAYING'" class="repaying-tip">
        <div class="tip-icon">
          <img src="@/assets/image/icons/icon-info-circle.png">
        </div>
        <div class="tip-text">
          {{ $t('repayingTip')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  i18n: {
    messages: {
      en: {
        balance: 'Balance',
        revenue: 'Total Revenue',
        repayingTip: 'Repayment is on process, unused balance will update tomorrow',
      },
      id: {
        balance: 'Nominal',
        revenue: 'Total Pendapatan',
        repayingTip: 'Penarikan sedang diproses, sisa nominal Anda akan di perbarui besok',
      },
    },
  },
  components: {},
  props: {
    recordList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {}
  },
  methods: {
    goToDetail(item) {
      this.$store.commit('updateCurrentRecord', item)
      this.$router.push({ name: 'UserRecordDetail', params: { type: this.$route.params.type } })
    },
  },
}
</script>

<style lang="stylus" scoped>
.no-data {
  text-align: center;
  padding: 20px;
}

.item {
  padding-top: 18px;
  border-bottom: 1px solid #eee;
  &:last-child {
    border-bottom: 0;
  }
  .item-header {
    padding: 0 21px 0 24px;
    display: flex;
    justify-content: space-between;
    .name {
      font-size: 18px;
    }
    .arrow {
      font-size: 10px;
    }
  }
  .item-content {
    padding: 0 21px 18px 24px;
    display: flex;
    justify-content: flex-start;
    .balance {
      width: 60%;
    }
    .content-label {
      font-size: 12px;
      color: #555;
      margin: 16px 0 10px;
    }
    .content-number {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .repaying-tip {
    padding: 10px 21px 10px 24px;
    display: flex;
    justify-content: flex-start;
    background: #f9f9f9;
    .tip-icon img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    .tip-text {
      color: #2C2E38;
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>
